import Auth from "@/components/Auth";
import ForgotPasswordPage from "@/screens/auth/forgot-password/ForgotPassword";
import LoginPage from "@/screens/auth/login/LoginPage";
import ResendInvitationSuccessPage from "@/screens/auth/resend-invitation-success/ResendInvitationSuccessPage";
import ResetPasswordPage from "@/screens/auth/reset-password/ResetPasswordPage";
import SignUpPage from "@/screens/auth/sign-up/SignUpPage";
import VerifyCodePage from "@/screens/auth/verify-code/VerifyCodePage";
import DiabetesPatientDetailsPage from "@/screens/patient-details/diabetes/DiabetesPatientDetailsPage";
import HypertensionPatientDetailsPage from "@/screens/patient-details/hypertension/HypertensionPatientDetailsPage";
import PatientListPage from "@/screens/patient-list/PatientListPage";
import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Outlet, Route, Routes } from "react-router";
import { Toaster } from "sonner";

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: console.error,
  }),
});

const App = () => {
  return (
    <>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <Routes>
            <Route
              path="/"
              element={
                <Auth>
                  <PatientListPage />
                </Auth>
              }
            />
            <Route path="login" element={<LoginPage />} />
            <Route path="verify-code" element={<VerifyCodePage />} />
            <Route path="sign-up" element={<SignUpPage />} />
            <Route path="resend-invitation-success" element={<ResendInvitationSuccessPage />} />
            <Route path="forgot-password" element={<ForgotPasswordPage />} />
            <Route path="reset-password" element={<ResetPasswordPage />} />
            <Route path="patients/:patientId" element={<Outlet />}>
              <Route
                path="diabetes"
                element={
                  <Auth>
                    <DiabetesPatientDetailsPage />
                  </Auth>
                }
              />
              <Route
                path="hypertension"
                element={
                  <Auth>
                    <HypertensionPatientDetailsPage />
                  </Auth>
                }
              />
            </Route>
          </Routes>
        </QueryClientProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </>
  );
};

export default App;
